module.exports = __webpack_public_path__ + "../resources/images/SkyCode_24-787850bb31639b751018988767235884.svg";